export default {
  signUpSuccess: 'Succesfully registered! You\'ve been signed in as well.',
  signUpFailure: 'Registration failed. Email may be taked, or passwords don\'t'
                  + ' match.',
  signInSuccess: 'Welcome!',
  signInFailure: 'Failed to sign in. Check your email and password and try' +
                  ' again.',
  signOutSuccess: 'Come back soon!',
  changePasswordSuccess: 'Password changed successfully!',
  changePasswordFailure: 'Failed to change passwords. Check your old password' +
                         ' and try again.',
  addPetSuccess: 'Your pet has been succesfully added!',
  addPetFailure: 'Ruff luck. Something went wrong.',
  addImageSuccess: 'What a purrfect picture!',
  addImageFailure: 'Ruff luck. We couldn\'t upload your image',
  addCareSuccess: 'Success!',
  addCareFailure: 'Ruff luck.'
}



// WEBPACK FOOTER //
// ./src/auth/messages.js